import styled from "styled-components";

export default styled.main`
    padding-bottom: 100px;
`;